/* Product page: start on M like the popup. A size already in the link wins. */
(function () {
  if (new URLSearchParams(location.search).has('variant')) return;
  customElements.whenDefined('variant-picker').then(function () {
    var m = document.querySelector('main variant-picker input[type="radio"][value="M" i]');
    if (m && !m.checked && m.dataset.optionAvailable === 'true') m.click();
  });
})();
